<div class="flex gap-4">
	<p
		class="hover:underline cursor-pointer"
		(click)="cancel()"
		*ngIf="canCancel"
		[testHook]="testHooks.CancelParagraph"
	>
		Cancel order
	</p>
	<p class="text-green underline cursor-pointer">
		<a
			externalNavInterceptor
			href="https://express.ctic.ca/secure/process.aspx?uc=ucQuote"
			target="_blank"
			[testHook]="testHooks.GetQuoteLink"
			>Get quote</a
		>
	</p>
</div>
